module.exports = __webpack_public_path__ + "static/media/logo.3ccfe465.png";


//////////////////
// WEBPACK FOOTER
// ./src/Assets/Images/logo.png
// module id = 1202
// module chunks = 0